import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// <ProtectedRoute isAuthOk={ ({xAppointment})=> xAppointment.ack !== null }>xxx</ProtectedRoute>
export default function ProtectedRoute2({ children, isAuthOk, ifFailGoTo }) {

  const state = useSelector((state) => state);
  const isOk = isAuthOk(state);

  if (!isOk) {
    return <Navigate to={ifFailGoTo} replace />;
  }

  return children;
}
